var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var card = {
    background: 'white',
    borderRadius: 2,
    boxShadow: "0 0 ".concat(4, "px ").concat('#cccccc'),
    display: 'block',
    height: '100%',
};
export var collapsibleCard = {
    border: '1px solid #cccccc',
    background: 'white',
    display: 'block',
    height: '100%',
};
export var footer = {
    alignItems: 'center',
    borderTop: '1px solid #cccccc',
    display: 'flex',
    padding: 16,
};
export var header = {
    borderBottom: '1px solid #cccccc',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    padding: "".concat(4, "px ").concat(16, "px"),
    textDecoration: 'none',
    minHeight: 32 + 1,
};
export var collapsibleHeader = {
    display: 'flex',
    alignItems: 'center',
    padding: "".concat(12, "px ").concat(16, "px"),
    textDecoration: 'none',
    minHeight: 32 + 1,
};
export var headerLink = __assign(__assign({}, header), { paddingRight: 24, ':focus': {
        boxShadow: "0 0 0 1px white, 0 0 0 3px ".concat('#085a7e'),
    } });
export var subHeader = {
    padding: "".concat(12, "px ").concat(16, "px 0"),
    fontSize: 14,
    lineHeight: 1.6,
    color: '#a6a6a6',
    fontWeight: '600',
};
export var title = {
    display: 'block',
    fontSize: 18,
    lineHeight: 1.45,
    flexGrow: 1,
    fontWeight: 'bold',
    margin: 0,
};
export var collapsibleTitle = {
    fontFamily: '"Open Sans", Helvetica, Arial, sans-serif',
    display: 'block',
    fontSize: 20,
    lineHeight: 1.38,
    flexGrow: 1,
    fontWeight: '300',
    margin: 0,
};
export var content = {
    padding: 16,
};
export var collapsibleContent = {
    padding: "0 ".concat(16, "px ").concat(12, "px ").concat(16, "px"),
    // transition: 'bottom .4s cubic-bezier(.645,.045,.355,1),top .4s cubic-bezier(.645,.045,.355,1)',
};
export var contentSubHeader = __assign(__assign({}, content), { paddingTop: 8 });
export var actionArea = {
    marginRight: -8,
};
export var icon = {
    display: 'inline-block',
    marginRight: 8,
    marginTop: 4 * -1,
    verticalAlign: 'middle',
};
